import React from "react";
import { KIND_LABELS } from "@/lib/marketing";

export const PlanSummary = ({ plan }) => {
  if (!plan) return null;
  return (
    <div className="grid sm:grid-cols-3 gap-4" data-testid="marketing-plan">
      {Object.entries(plan.kinds).map(([k, v]) => {
        const done = v.published + v.scheduled;
        const ok = done >= v.target;
        return (
          <div key={k} className="vg-card p-4" data-testid={`plan-${k}`}>
            <p className="text-xs font-bold uppercase tracking-wide text-gray-500">{KIND_LABELS[k]}</p>
            <p className="text-2xl font-bold text-[#0A0A0A] mt-1">{done}<span className="text-sm text-gray-400 font-semibold"> / {v.target}</span></p>
            <p className={`text-xs mt-1 ${ok ? "text-green-700" : "text-[#B40101]"}`}>{v.published} pubblicati · {v.scheduled} programmati</p>
          </div>
        );
      })}
      {plan.campaigns && (
        <div className="vg-card p-4 sm:col-span-3" data-testid="plan-campaigns">
          <p className="text-xs font-bold uppercase tracking-wide text-gray-500">Campagne email del mese (max {plan.campaigns.limit})</p>
          <p className="text-2xl font-bold text-[#0A0A0A] mt-1" data-testid="plan-campaigns-used">{plan.campaigns.used}<span className="text-sm text-gray-400 font-semibold"> / {plan.campaigns.limit}</span></p>
          <ul className="text-xs text-gray-600 mt-1 space-y-0.5">
            {plan.campaigns.items.map((c) => (
              <li key={c.slot_id} data-testid={`plan-campaign-${c.slot_id}`}>{c.status === "executed" ? "Inviata" : "Prenotata"} · {c.title || c.content_id}</li>
            ))}
          </ul>
        </div>
      )}
    </div>
  );
};
